export enum WithdrawalMethodsQueryKeys {
  Primary = '/withdrawal-methods/',
  ById = '/withdrawal-methods/:id',
}
